<!-- New Sign In -->
<div class="sign-in-box-container" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <div class="sign-in-box-inner-container">

    <div class="logo-box p-g-12 p-md-1 p-lg-1 p-g-nopad">
      <img src=''>
    </div>

    <div class="logo-box p-g-12 p-md-6 p-lg-6 p-g-nopad">
      <div>
        <div class="form-field p-g-4 p-g-nopad">
          <img src='/assets/images/temp/nbx_login_logo.svg'>
        </div>
        <div class="form-field p-g-12 p-g-nopad">
          <h2>{{signInWelcomeTextLabel}}</h2>
        </div>

        <div class="form-field p-g-11 p-g-nopad">
          <h4>{{signInDescription}}</h4>
        </div>

        <!-- <div class="form-field p-g-12 p-g-nopad">
          <div class="form-field p-g-3 p-g-nopad">
            <a class="read-more-label" style="color:#FFF;font-weight: bold;" target="_blank">
              <span>{{readMoreLabel}}</span>
            </a>
          </div>
        </div> -->
      </div>
    </div>

    <div class="sign-in-box p-g-12 p-md-4 p-lg-4 p-g-nopad">
      <p-panel>
        <div class="form-field p-g-12 p-g-nopad">
          <div class="form-errors alert alert-danger" [hidden]="!loginErrors.general.hasError">
            <div *ngFor="let ErrorMessage of loginErrors.general.error">
              {{ErrorMessage.message}}
            </div>
          </div>
        </div>

        <div class="form-field p-g-12 p-g-nopad">
          <div class="form-field p-g-12 switch-btn">Login</div>
          <div class="form-field p-g-12 selected-menu"></div>
        </div>

        <!-- <app-login (onSignInEmitter)="doSignIn($event)" (onForgotPasswordEmitter)="forgotPassword()"></app-login> -->
        <form [formGroup]='signInForm'>
          <div class="form-field p-g-12 bottom-border">
            <div class="form-field p-g-2 p-g-nopad ">
              <i class="fa fa-envelope sign-in-icon" aria-hidden="true"></i>
            </div>
            <div class="form-field p-g-10 p-g-nopad">
              <input formControlName="username" id="username" placeholder="{{usernamePlaceholder}}"
                class="full-width-transperent" type="text" pInputText (keypress)="eventHandler($event)"
                aria-labelledby="ariaLabelErrorUsername" aria-required="true" appNoWhiteSpace />
              <div class="form-errors" id="ariaLabelErrorUsername"
                *ngIf="signInForm.controls.username.errors  && (signInForm.controls.username.dirty || signInForm.controls.username.touched || submitted)">
                <div [hidden]="!signInForm.controls.username.errors.required" translate>
                  email_required
                </div>
              </div>
            </div>
          </div>

          <div class="form-field p-g-12 bottom-border">
            <div class="form-field p-g-2 p-g-nopad ">
              <i class="fa fa-key sign-in-icon" aria-hidden="true"></i>
            </div>
            <div class="form-field p-g-10 p-g-nopad" style="position: relative;">
              <input pInputText [type]="showPassword? 'text':'password'" id="password" formControlName="password"
                placeholder="{{passwordPlaceHolder}}" class="full-width-transperent pr-5" (keypress)="eventHandler($event)"
                aria-labelledby="ariaLabelErrorPassword" aria-required="true" />
                <li [class]="showPassword? 'fa fa-eye' : 'fa fa-eye-slash'" (click)="showPassword = !showPassword" style="position: absolute;top: 16px;right: 10px;"></li>
              <div class="form-errors" id="ariaLabelErrorPassword"
                *ngIf="signInForm.controls.password.errors  && (signInForm.controls.password.dirty || signInForm.controls.password.touched  || submitted)">
                <div [hidden]="!signInForm.controls.password.errors.required" translate>
                  error_password_required
                </div>
              </div>
            </div>
          </div>

          <div class="form-field p-g-12">
            <a href="javascript:;" (click)="forgotPassword()" class="forgot-password-link" translate>forgot_password</a>
          </div>

          <div class="form-field p-g-12">
            <div class="form-field p-g-4 p-g-nopad">
              <img src=''>
            </div>
            <div class="form-field p-g-4 p-g-nopad">
              <button pButton label="{{signInLabel}}" class='sign-in-buttons' type="button"
                (click)="doSignIn()"></button>
            </div>

          </div>
        </form>
        <div style="clear: both;"></div>

      </p-panel>

    </div>


    <div class="powered-by-section p-g-12">
      <div class="col-12 wrapper">
        <div class="text-center; position:relative">
          <a target="_blank" href="https://mobisoftinfotech.com/solutions/event-transportation-management-app">
            <img [src]="poweredByLogo" style="width:180px; position: absolute;bottom: 8px; right: 50%;">
          </a>
        </div>
      </div>
    </div>

  </div>
</div>



<p-dialog modal="true" header="Forgot Password" styleClass="edit-popup" position="center center" responsive="true"
  [(visible)]="forgotPopup" [closable]="false">
  <app-forgot-password (onPopClose)="onPopClose($event)" (onPopSave)="onPopSave($event)"></app-forgot-password>
</p-dialog>

<p-dialog modal="true" header="Validate OTP" styleClass="edit-popup" position="center center" responsive="true"
  [(visible)]="otpPopup" [closable]="false">
  <!-- <p-header>
    Validate OTP
  </p-header> -->
  @if(otpPopup) {
  <app-otp-verifiy [email]="otpEmail" [phone]="otpPhone" (onOtpPopClose)="onOtpPopClose($event)"
    (onOtpPopSave)="onOtpPopSave($event)"></app-otp-verifiy>
  }
</p-dialog>

<p-dialog modal="true" header="Set Password" styleClass="edit-popup" position="center center" responsive="true"
  [(visible)]="setPasswordPopup" [closable]="false">
  <!-- <p-header>
    Validate OTP
  </p-header> -->
  <app-set-password [otpId]="otpId" (onSetPasswordPopClose)="onSetPasswordPopClose($event)"></app-set-password>
</p-dialog>

<!-- End Sign In -->


<!-- <div class="signin-box-container p-g">
  <div class="signin-box-inner-container">
    <div class="signin-box p-g-10 p-md-6 p-lg-6 p-g-nopad">
      <div class="company-logo">
        <img width="200" src="/assets/images/temp/header-logo.png">
      </div>

      <p-panel header="Sign In">
        <form [formGroup]='signInForm'>
          <div class="form-container p-g">
            <div class="form-errors">
              <div [hidden]="!loginErrors.general.hasError" class="alert alert-danger">
                <div *ngFor="let ErrorMessage of loginErrors.general.error">
                  {{ErrorMessage.message}}
                </div>
              </div>
            </div>

            <div class="form-field p-g-12 p-g-nopad">
              <div class="form-label">
                <label for="username" translate>Username</label>
              </div>
              <div class="form-control">
                <input formControlName="username" class="full-width" type="text" pInputText (keypress)="eventHandler($event)" />
              </div>
              <div class="form-errors" *ngIf="signInForm.controls.username.errors  && (signInForm.controls.username.dirty || signInForm.controls.username.touched)">
                <div [hidden]="!signInForm.controls.username.errors.required" translate>
                    email_required
                </div>
              </div>
            </div>

            <div class="form-field p-g-12 p-g-nopad">
              <div class="form-label">
                <label for="passwd" translate> Password </label>
              </div>
              <div class="form-control">
                <input formControlName="password" type="password" class="full-width" (keypress)="eventHandler($event)" pInputText/>
                <div [hidden]="!loginErrors.password.hasError" class="alert alert-danger">
                  <div *ngFor="let ErrorMessage of loginErrors.password.error">
                    {{ErrorMessage.message}}
                  </div>
                </div>
              </div>
              <div class="form-errors" *ngIf="signInForm.controls.password.errors  && (signInForm.controls.password.dirty || signInForm.controls.password.touched)">
                <div [hidden]="!signInForm.controls.password.errors.required">
                  {{'Password is required'}}
                </div>
              </div>

              <div class="form-buttons p-g-12 p-g-nopad">
                <a (click)="forgotPassword()" class="forgot-password-link" translate >forgot_password</a>
                <button pButton label="Sign In" type="button" [disabled]="!signInForm.valid" (click)="doSignIn()"></button>
              </div>
            </div>
          </div>
        </form>
      </p-panel>

    </div>
  </div>
</div>


<p-dialog modal="false" styleClass="edit-popup" position="center center" responsive="true" [(visible)]="forgotPopup" [closable]="false">
  <p-header>
    Forgot Password
  </p-header>
  <app-forgot-password (onPopClose)="onPopClose($event)" (onPopSave)="onPopSave($event)"></app-forgot-password>
</p-dialog>

<p-dialog modal="false" styleClass="edit-popup" position="center center" responsive="true" [(visible)]="otpPopup" [closable]="false">
  <p-header>
    Validate OTP
  </p-header>
  <app-otp-verifiy [email]="otpEmail" [phone]="otpPhone"(onOtpPopClose)="onOtpPopClose($event)" (onOtpPopSave)="onOtpPopSave($event)"></app-otp-verifiy>
</p-dialog>

<p-dialog modal="false" styleClass="edit-popup" position="center center" responsive="true" [(visible)]="setPasswordPopup" [closable]="false">
  <p-header>
    Validate OTP
  </p-header>
  <app-set-password [otpId]="otpId" (onSetPasswordPopClose)="onSetPasswordPopClose($event)"></app-set-password>
</p-dialog>

 -->